import { type OptionsFetchQueryResult, OptionsType } from '@openx/types/options.ts';
import type { UseQueryOptions } from '@openx/types/reactQuery.ts';
import { useTranslation } from 'react-i18next';

import { useOptionsFetch } from './generics/useOptionsFetch.tsx';

export function useScreenResolutionOptionsFetch(queryOptions?: UseQueryOptions<OptionsFetchQueryResult>) {
  const { t } = useTranslation();
  const {
    isLoading: isScreenResolutionOptionsLoading,
    data: screenResolutionOptions,
    refetch: refetchScreenResolutionOptions,
  } = useOptionsFetch({
    errorMessage: t('Failed to fetch Screen Resolution options'),
    optionType: OptionsType.SCREEN_RESOLUTION,
    queryOptions,
  });

  return {
    isScreenResolutionOptionsLoading,
    refetchScreenResolutionOptions,
    screenResolutionOptions,
  };
}
